import React from "react";
import { Text, withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";

const MyClients = (props) => {
  return (
    <>
      <Text field={props.fields.heading} />
    </>
  );
};

export default withSitecoreContext()(MyClients);
